<template>
  <Dropdown
    v-model="nextRoute"
    data-cy="dropdown"
    :options="finalRoutes"
    :placeholder="title"
    optionLabel="name"
    optionValue="name"
    append-to="body"
    panelClass="equipment-nav"
  />
</template>

<script setup lang="ts">
import type {
  BaseEquipment,
  UseEquipment
} from "@/composables/equipment/equipmentTypes";
import { injectStrict } from "@/utils/utils";
import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import equipmentRoutes from "@/router/config/equipment";

const nextRoute = ref("");
const router = useRouter();
const equipment = injectStrict<UseEquipment<BaseEquipment>>("equipment");

// Change route when dropdown changes
watch(nextRoute, newRoute => {
  if (newRoute) {
    router.push({ name: newRoute });
  }
});

const finalRoutes = computed(() => {
  return equipmentRoutes.filter(route => route.name !== equipment.title);
});

const title = equipment.title;
</script>
